var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('DataManagerOm'),_vm._v(" "),_c('hr'),_c('DataManagerCsm'),_vm._v(" "),_c('hr'),_c('DataManagerMediaAnalyst'),_vm._v(" "),_c('hr')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"/apps/script-tags/data-manager"}},[_vm._v("Back to data manager")])])
}]

export { render, staticRenderFns }